var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 1.66699V5.00033M5.66667 1.66699V5.00033M1.5 8.33366H16.5M3.16667 3.33366H14.8333C15.7538 3.33366 16.5 4.07985 16.5 5.00033V16.667C16.5 17.5875 15.7538 18.3337 14.8333 18.3337H3.16667C2.24619 18.3337 1.5 17.5875 1.5 16.667V5.00033C1.5 4.07985 2.24619 3.33366 3.16667 3.33366Z",
    stroke: "#A4A7AE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2);
export default __webpack_public_path__ + "static/media/calendar2.41f134b0110a60921598aebbffb93cd6.svg";
export { ForwardRef as ReactComponent };